import request from "@utils/request";

/**
 *  激活购物卡
 */
export function sendCode(data) {
    return request.post('micro_client/bind_uid',data);
}

/**
 *  消费扶贫专区
 */
export function getFuPingList() {
    return request.get('FuPingCategory',{}, { login: false });
}

/**
 *  花市专区
 */
export function getFlowerList() {
    return request.get('FlowerCategory',{}, { login: false });
}

/**
 *  客都优选专区
 */
export function getKeduList() {
    return request.get('KeduCategory');
}